module.exports = __webpack_public_path__ + "img/c45d0b0.png";